// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"11fb4e96","140":"25b9a102","161":"85a4f270","209":"2d43f3f5","478":"9f030c75","625":"6bd76b46","922":"0fc09f2e"}[chunkId] + ".chunk.js";
};